import React, { Component } from "react";
import Joi from "joi-browser";
import logo from "../assets/images/sdc-cocina-saludable.png";
import dispositivos from "../assets/images/dispositivos.png";
import acceso from "../assets/images/ic-acceso-mail.png";
import descarga from "../assets/images/ic-descarga.png";
import calendario from "../assets/images/ic-calendario.png";
import tips from "../assets/images/ic-tips.png";
import videoconferencia from "../assets/images/ic-videoconferencia.png";
import telefonoColor from "../assets/images/ic-telefono_rojo.png";
import completar from "../assets/images/ic-completar.png";
import medios from "../assets/images/medios.png";
import payways from "../assets/images/payways.png";
import { getCountries, getProvinces } from "../services/locationService";
import { getPlans } from "../services/plansService";
import { getSubscriptionPlans } from "../services/subscriptionPlansService";
import { checkout } from "../services/checkoutService";
import { vars } from "../utils/variables";
import Form from "./common/form";
import $ from "jquery";

class Home extends Form {
  state = {
    data: {
      name: "",
      lastname: "",
      email: "",
      email2: "",
      countryId: "11",
      payway: vars("payway"),
      productId: vars("sixMonthsPlanProductId"), //vars("productId")
      canalId: vars("canalId"),
      mktCodeId: vars("mktCodeId"),
      campaignId: vars("sixMonthsPlanCampaignId"),
      weight: "",
      height: "",
      planId: "",
      category: "",
      expectations: "",
    },
    showUserForm: false,
    selectedSubscriptionPlanId: vars("sixMonthsPlanId"),
    subscriptionPlans: [],
    plans: [],
    countries: [],
    provinces: [],
    errors: {},
  };

  schema = {
    name: Joi.string()
      .max(15)
      .required()
      .error(() => {
        return {
          message: "El nombre es requerido",
        };
      }),
    lastname: Joi.string()
      .max(15)
      .required()
      .error(() => {
        return {
          message: "El apellido es requerido.",
        };
      }),
    email: Joi.string()
      .max(50)
      .required()
      .error(() => {
        return {
          message: "El email es requerido y debe ser un email válido.",
        };
      }),
    email2: Joi.string()
      .max(50)
      .required()
      .error(() => {
        return {
          message: "El email es requerido y debe ser un email válido.",
        };
      }),
    weight: Joi.string().allow(""),
    height: Joi.string().allow(""),
    planId: Joi.string()
      .required()
      .error(() => {
        return {
          message:
            "SELECCIONA EL PERFIL SOBRE EL QUE QUIERAS BASAR TU PROGRAMA",
        };
      }),
    countryId: Joi.string()
      .required()
      .error(() => {
        return {
          message: "Debes seleccionar un país",
        };
      }),
    // provinceId: Joi.string().allow(""),
    extra_data1: Joi.string().allow(""),
    extra_data2: Joi.string().allow(""),
    payway: Joi.string().allow(""),
    productId: Joi.number(),
    canalId: Joi.string().allow(""),
    mktCodeId: Joi.string().allow(""),
    campaignId: Joi.number(),
    category: Joi.string().allow(""),
    expectations: Joi.string().allow(""),
  };

  populateCountries = async () => {
    const { data } = await getCountries();
    this.setState({ countries: data.data });
  };

  // populateProvinces = async () => {
  //   const { data } = await getProvinces();
  //   this.setState({ provinces: data.data });
  // };

  populatePlans = async () => {
    const plans = getPlans();
    this.setState({ plans });
  };

  populateSubscriptionPlans = async () => {
    const plans = getSubscriptionPlans();
    this.setState({ subscriptionPlans: plans });
  };

  componentDidMount() {
    this.populateCountries();
    this.populateSubscriptionPlans();
    this.populatePlans();
    const canalId = this.getQueryStringValue("canalID");
    if (canalId !== "") {
      const { data } = this.state;
      data["canalId"] = canalId;
      this.setState({ data });
    }
  }

  getQueryStringValue(key) {
    return decodeURIComponent(
      window.location.search.replace(
        new RegExp(
          "^(?:.*[&\\?]" +
            encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
            "(?:\\=([^&]*))?)?.*$",
          "i"
        ),
        "$1"
      )
    );
  }

  normalizeAccents = (string) => {
    string = string.replace("&aacute;", "á");
    string = string.replace("&eacute;", "é");
    string = string.replace("&iacute;", "í");
    string = string.replace("&oacute;", "ó");
    string = string.replace("&uacute;", "ú");
    return string;
  };

  selectSubscriptionPlan = (id, productId) => {
    const { data } = this.state;
    data.productId = productId;
    const selectedSubscriptionPlanId = id;
    const selectedPlan = this.state.subscriptionPlans.find(
      (p) => p._id === selectedSubscriptionPlanId
    );
    data.campaignId = selectedPlan.campaignId;
    this.setState({ data, selectedSubscriptionPlanId, showUserForm: true });
  };

  handleEmailConfirmation = async (e) => {
    await this.handleChange(e);
    const { data, errors } = this.state;
    // console.log(input.name, input.value);
    console.log(data.email, data.email2);
    console.log(data.email === data.email2);
    if (data.email != data.email2) {
      // swal("Revisa tus datos", res.msg, "error");
      errors.email2 = "Los emails no coinciden";
    } else {
      if (errors.hasOwnProperty("email2")) delete errors.email2;
    }

    this.setState({ errors });
  };

  doSubmit = async () => {
    console.log("sending...");

    const extra_data = JSON.stringify({
      weight: this.state.data.weight,
      height: this.state.data.height,
      planId: this.state.data.planId,
      planName: this.state.plans.find((p) => p._id === this.state.data.planId)
        .name,
      selectedSubscriptionPlanId: this.state.selectedSubscriptionPlanId,
      selectedSubscriptionPlanName: this.state.subscriptionPlans.find(
        (p) => p._id === this.state.selectedSubscriptionPlanId
      ).name,
      expectations: this.state.data.expectations,
    });
    const { data } = await checkout({
      ...this.state.data,
      extra_data1: extra_data,
      // extra_data2: this.state.data.height,
      // expectations: this.state.data.planId,
      selectedSubscriptionPlanId: this.state.selectedSubscriptionPlanId,
    });
    console.log(data);
    if (data.success) {
      if (vars("isInternational")) {
        window.userId = data.userId;
        console.log("window.userId", window.userId);
        const userCredentials = {
          email: this.state.data.email,
          firstName: this.state.data.name,
          lastName: this.state.data.lastname,
        };
        // userCredentials.addressLine1 = userData.address;
        // userCredentials.city = userData.cityId;
        // userCredentials.region = userData.provinceId;
        // userCredentials.postalCode = userData.zipId;
        userCredentials.country = this.state.data.country;
        // userCredentials.phoneNumber = userData.phonePrefix + userData.phone;
        // console.log(userCredentials);
        $("#fs-btn").attr("data-fsc-item-path-value", data.fspath);
        // $('#fs-btn').click();
        window.fastspring.builder.add(
          $("#fs-btn").attr("data-fsc-item-path-value")
        );
        window.fastspring.builder.recognize(userCredentials);
        window.fastspring.builder.checkout();
      } else window.location.assign(data.url);
    }
  };

  render() {
    const { errors } = this.state;
    return (
      <>
        <header>
          <div className="container">
            <div className="row">
              <div className="col-7 pr-0 d-flex align-items-center">
                <img className="logo mr-2" src={logo} alt="Cocina Saludable" />
                <span className="slogan">
                  Una nueva manera
                  <br /> de alimentarte
                </span>
              </div>
              <div className="col-5 pl-0 text-right pt-4">
                <a
                  className="btn btn-outline btn-up d-inline-block mb-4"
                  href="#conocerte"
                >
                  Empezar Ahora
                </a>
              </div>
            </div>
          </div>
        </header>

        <section id="principal">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6">
                <h1 className="text-center text-md-left">
                  Comenzar a comer saludablemente nunca fue tan fácil.
                </h1>
                <p>
                  ¿No sabes por dónde empezar? Te acompañamos con riquísimas
                  recetas e información útil sobre los alimentos. Te invitamos a
                  poner en práctica ideas fáciles y resolvemos tu semana con
                  planes personalizados para lograr un menú completo y
                  saludable.
                </p>
                <p>
                  <strong>
                    Recibirás 3 correos electrónicos semanales con:
                  </strong>
                </p>
                <ul className="list-items mb-4">
                  <li className="mb-2">
                    <i className="fa fa-check-square mr-2" />
                    La información que necesitas para incorporar de una vez por
                    todas nuevos alimentos a tu dieta.
                  </li>
                  <li className="mb-2">
                    <i className="fa fa-check-square mr-2" />
                    Consejos y recomendaciones para cumplir con tu objetivo
                    nutricional.
                  </li>
                  <li>
                    <i className="fa fa-check-square mr-2" />
                    Recetas saludables y fáciles de preparar en casa.
                  </li>
                </ul>
                <div className="text-center text-sm-left">
                  <a
                    className="btn btn-outline d-inline-block mb-4"
                    href="#conocerte"
                  >
                    Empezar Ahora
                  </a>
                </div>
              </div>
              <div className="col-12 col-md-6 d-flex align-items-strech">
                <div className="dispositivos position-relative text-center">
                  <img
                    className="img-fluid"
                    src={dispositivos}
                    alt="Recibirás 3 correos electrónicos semanales"
                  />
                  <div className="circle-red red text-center">
                    <p className="text-white">
                      Disponible <br />
                      en tu correo electrónico
                    </p>
                    <p className="text-white">
                      Desde {vars("sixMonthsPlanPrice")} <br />
                      <span style={{ fontWeight: "100" }}>POR MES</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="membresia" className="text-center my-3">
          <div className="container">
            <div className="row">
              <div className="col">
                <h3>Tu membresía también incluye:</h3>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <img
                  className="d-inline-block mb-3"
                  src={acceso}
                  alt="Acceso desde dispositivos"
                />
                <p>Acceso desde cualquier dispositivo.</p>
              </div>
              <div className="col">
                <img
                  className="d-inline-block mb-3"
                  src={descarga}
                  alt="Ebooks descargables"
                />
                <p>Ebooks descargables.</p>
              </div>
              <div className="col">
                <img
                  className="d-inline-block mb-3"
                  src={calendario}
                  alt="Plan semanal de alimentación saludable"
                />
                <p>
                  Cada mes, un plan semanal de alimentación saludable
                  personalizado.
                </p>
              </div>
              <div className="col">
                <img
                  className="d-inline-block mb-3"
                  src={tips}
                  alt="Tips e información para estar saludable"
                />
                <p>
                  Tips e información para estar saludable en todos los aspectos
                  de tu vida.
                </p>
              </div>
              <div className="col">
                <img
                  className="d-inline-block mb-3"
                  src={videoconferencia}
                  alt="Videoconferencias exclusivas"
                />
                <p>Videoconferencias exclusivas con especialistas.</p>
              </div>
              {!vars("isInternational") && (
                <div className="col">
                  <img
                    className="d-inline-block mb-3"
                    src={telefonoColor}
                    alt="Servicio telefónico gratuito "
                  />
                  <p>Servicio telefónico de asistencia nutricional.</p>
                </div>
              )}
              <div className="col-12 text-center d-sm-none">
                <a
                  className="btn btn-outline d-inline-block mb-4"
                  href="#conocerte"
                >
                  Empezar Ahora
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="text-center my-5" id="conocerte">
          <div className="container">
            <div className="row">
              <div className="col">
                <h3>¡Queremos conocerte un poco más!</h3>
              </div>
            </div>
          </div>
        </section>
        <section id="datos-plan" className="lightgrey">
          <div className="container">
            <div className="row mx-sm-0 d-flex mb-4 datos position-relative">
              <div className="col-12 col-md-6 red">
                <div className="p-3">
                  <h3 className="text-white text-center text-md-left">
                    Necesitamos un poco más de información sobre ti y de tus
                    expectativas.
                  </h3>
                </div>
              </div>
              <div className="col-12 col-md-6 bg-white">
                <div className="p-3">
                  <div className="form-group input-group-sm">
                    <label htmlFor="peso">Ingresá tu peso</label>
                    <input
                      onChange={this.handleChange}
                      name="weight"
                      placeholder="Ej: 68,4 kg"
                      type="text"
                      id="peso"
                      className={
                        "form-control" + (errors["weight"] ? " is-invalid" : "")
                      }
                    />
                    {errors["weight"] && (
                      <div className="alert alert-danger">
                        {errors["weight"]}
                      </div>
                    )}
                  </div>
                  <div className="form-group input-group-sm">
                    <label htmlFor="altura">Ingresá tu altura *</label>
                    <input
                      onChange={this.handleChange}
                      name="height"
                      type="text"
                      placeholder="Ej: 1,68 m"
                      className="form-control"
                      id="altura"
                      className={
                        "form-control" + (errors["height"] ? " is-invalid" : "")
                      }
                    />
                    {errors["height"] && (
                      <div className="alert alert-danger">
                        {errors["height"]}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row position-relative datos2">
              <div className="col-12 mb-4 text-center">
                <h4>
                  Selecciona el perfil sobre el que quieras basar tu programa
                </h4>
              </div>
              <div className="col-12">
                {errors["planId"] && (
                  <div className="alert alert-danger">{errors["planId"]}</div>
                )}
              </div>
              {this.state.plans.map((plan) => (
                <div className="col-12 col-lg-4 mb-4 mb-md-0" key={plan._id}>
                  <div className="form-check">
                    <input
                      onChange={this.handleChange}
                      className={
                        "form-check-input" +
                        (errors["planId"] ? " is-invalid" : "")
                      }
                      type="radio"
                      name="planId"
                      value={plan._id}
                      id={plan._id}
                    />
                    <label className="form-check-label" htmlFor={plan._id}>
                      <strong>{plan.name}</strong>
                      <br /> {plan.description}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="planes">
          <div className="container">
            <div className="row">
              <div className="col text-center mb-2 mb-md-4">
                <h3>¿Qué valor tienen tu salud y bienestar?</h3>
                <p>
                  Lo único que falta para cambiar tu alimentación es que te
                  decidas a dar el paso. Elige tu plan y ¡comienza a cambiar tus
                  hábitos hoy mismo!
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2 hidden-xs"></div>
              {this.state.subscriptionPlans.map((plan) => (
                <div className="col-12 col-md-4 " key={plan._id}>
                  <div className="text-center">
                    {plan.name === "Semestral" && (
                      <a className="btn btn-outline-danger">Recomendado</a>
                    )}
                    {plan.name === "Mensual" && (
                      <a
                        className="btn btn-outline-danger"
                        style={{ opacity: 0 }}
                      >
                        Mensual
                      </a>
                    )}
                  </div>

                  <div
                    style={{ cursor: "pointer" }}
                    className={
                      "box-precio text-center pt-4 pb-4 mb-4" +
                      (plan._id === this.state.selectedSubscriptionPlanId
                        ? " box-destacado red"
                        : " lightgrey")
                    }
                    onClick={() =>
                      this.selectSubscriptionPlan(plan._id, plan.productId)
                    }
                  >
                    <h4>{plan.name}</h4>
                    <div className="circle d-flex flex-column justify-content-center">
                      {plan.originalPricePerMonth && (
                        <p
                          style={{
                            fontSize: ".8rem",
                            fontWeight: "bold",
                            textTransform: "upperCase",
                          }}
                        >
                          Ahorra un 20%
                        </p>
                      )}
                      {/* <p
                        className=""
                        style={{ textDecoration: "line-through" }}
                      >
                        {plan.originalPricePerMonth}
                      </p> */}
                      <div>
                        <p className="precioAr mb-1">
                          {/* <span>{vars("currency")}</span> */}
                          {plan.price}
                        </p>
                      </div>
                      <small className="d-inline-block text-uppercase">
                        Por mes
                      </small>
                      <p className="mb-0 mt-2" style={{ fontSize: ".65rem" }}>
                        {plan.pricePerMonth && (
                          <span>
                            Cada 6 meses realiza un
                            <br />
                            débito de{" "}
                          </span>
                        )}
                        {plan.pricePerMonth}
                      </p>
                    </div>
                    <a
                      href="#detalle-compra"
                      className={
                        "btn " +
                        (plan._id === this.state.selectedSubscriptionPlanId
                          ? " btn-light"
                          : " btn-outline")
                      }
                    >
                      Unirme Ahora
                    </a>
                  </div>
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col">
                <p>
                  <strong>
                  Una vez que la transacción sea aprobada, recibirás en tu casilla un correo con la confirmación de tu suscripción. No dejes de revisar tu carpeta de spam.
                  </strong>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col text-center">
                <img src={vars("isInternational") ? payways: medios} alt="Medios de pago" style={{maxWidth:300}} />
              </div>
            </div>
          </div>
        </section>
        {this.state.showUserForm && (
          <div id="detalle-compra">
            <form>
              <section id="datos-personales">
                <div className="container">
                  <div className="row">
                    <div className="col-6">
                      <h4>Completa tus datos personales</h4>
                    </div>
                    <div className="col-6 text-right">
                      <img src={completar} alt />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-6">
                      <div className="form-group input-group-sm">
                        <label htmlFor="nombre">Nombre</label>
                        <input
                          maxLength="15"
                          onChange={this.handleChange}
                          name="name"
                          type="text"
                          id="nombre"
                          className={
                            "form-control" +
                            (errors["name"] ? " is-invalid" : "")
                          }
                        />
                        {errors["name"] && (
                          <div className="alert alert-danger">
                            {errors["name"]}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6">
                      <div className="form-group input-group-sm">
                        <label htmlFor="apellido">Apellido</label>
                        <input
                          onChange={this.handleChange}
                          maxLength="15"
                          name="lastname"
                          type="text"
                          id="apellido"
                          className={
                            "form-control" +
                            (errors["lastname"] ? " is-invalid" : "")
                          }
                        />
                        {errors["lastname"] && (
                          <div className="alert alert-danger">
                            {errors["lastname"]}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6">
                      <div className="form-group input-group-sm">
                        <label htmlFor="mail">Email</label>
                        <input
                          onChange={this.handleEmailConfirmation}
                          name="email"
                          type="email"
                          id="mail"
                          className={
                            "form-control" +
                            (errors["email"] ? " is-invalid" : "")
                          }
                        />
                        {errors["email"] && (
                          <div className="alert alert-danger">
                            {errors["email"]}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6">
                      <div className="form-group input-group-sm">
                        <label htmlFor="mail-2">Confirma tu mail</label>
                        <input
                          onChange={this.handleEmailConfirmation}
                          type="email"
                          maxLength="50"
                          name="email2"
                          placeholder=""
                          className={
                            "form-control" +
                            (errors["email2"] ? " is-invalid" : "")
                          }
                        />
                        {errors["email2"] && (
                          <div className="alert alert-danger">
                            {errors["email2"]}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6">
                      <div className="form-group input-group-sm">
                        <label htmlFor="Pais">País</label>
                        {this.state.countries && (
                          <select
                            name="countryId"
                            value={this.state.data.countryId}
                            className={
                              "form-control" +
                              (errors["countryId"] ? " is-invalid" : "")
                            }
                            onChange={this.handleChange}
                          >
                            <option value="">Seleccionar</option>
                            {this.state.countries.map((country) => (
                              <option
                                key={country.idTPais}
                                value={country.idTPais}
                              >
                                {this.normalizeAccents(country.TP_Pais)}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    </div>
                    <div className="col-12 col-sm-6">
                      <div className="form-group input-group-sm">
                        <label htmlFor="expectations">
                          ¿Qué esperas aprender? ¿En qué podemos ayudarte?
                        </label>
                        <input
                          onChange={this.handleChange}
                          name="expectations"
                          type="text"
                          id="expectations"
                          className={
                            "form-control" +
                            (errors["expectations"] ? " is-invalid" : "")
                          }
                        />
                        {errors["expectations"] && (
                          <div className="alert alert-danger">
                            {errors["expectations"]}
                          </div>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-12 col-sm-6">
                    <div className="form-group input-group-sm">
                      <label>Provincias</label>
                      {provinces && (
                        <select
                          name="provinceId"
                          className={
                            "form-control" +
                            (errors["provinceId"] ? " is-invalid" : "")
                          }
                          onChange={this.handleChange}
                        >
                          <option value="">Seleccionar</option>
                          {provinces.map((province) => (
                            <option
                              key={province.idTProvincia}
                              value={province.idTProvincia}
                            >
                              {province.TP_Provincia}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div> */}
                  </div>
                  <div className="row">
                    {/* <div className="col-12">
                      <p>Seleccioná tu método de pago</p>
                      <div className="col-12">
                        {errors["payway"] && (
                            <div className="alert alert-danger">
                              {errors["payway"]}
                            </div>
                          )}
                      </div>
                      <div className="form-check form-check-inline mr-4">


                        <input
                          onChange={this.handleChange}
                          className={
                            "form-check-input" +
                            (errors["payway"] ? " is-invalid" : "")
                          }
                          className="form-check-input"
                          type="radio"
                          name="payway"
                          id="mp"
                          value="mp"
                          checked={this.state.data.payway === 'mp'} 
                        />
                        <label
                          className="form-check-label mr-3"
                          htmlFor="mp"
                        >
                          ARS<strong>99,00</strong>
                        </label>
                        <img
                          className="d-inline-block mr-2"
                          src={mercadopago}
                          alt="Mercado Pago"
                        />
                        <span>
                          <small>Solo Argentina</small>
                        </span>
                      </div>
                      <div className="form-check form-check-inline">
                        <input
                          className={
                            "form-check-input" +
                            (errors["payway"] ? " is-invalid" : "")
                          }
                          className="form-check-input"
                          type="radio"
                          name="payway"
                          id="fs"
                          value="fs"
                          checked={this.state.data.payway === 'fs'} 
                        />
                        <label
                          className="form-check-label mr-3"
                          htmlFor="fs"
                        >
                          USD <strong>2</strong>
                        </label>
                        <img
                          className="d-inline-block mr-2"
                          src={paypal}
                          alt="PayPal"
                        />
                        <span>
                          <small>Resto de países</small>
                        </span>
                      </div>
                    </div> */}
                    <div className="col-12 mt-4 text-center">
                      <button
                        onClick={this.handleSubmit}
                        className="btn btn-danger"
                      >
                        Comprar
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 pt-2">
                      {Object.keys(errors).map(
                        (keyName) =>
                          errors[keyName] && (
                            <div className="alert alert-danger">
                              {errors[keyName]}
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </form>
          </div>
        )}
      </>
    );
  }
}

export default Home;
